module.exports = "/static/assets/c37c766fb74ec35d5ca9d9c61f10e681.png";